import Vue from 'vue'
import { ToastPlugin, ModalPlugin, VBTooltipPlugin } from 'bootstrap-vue'
import VueLodash from 'vue-lodash'
import VueCompositionAPI from '@vue/composition-api'
import Print from 'vue-print-nb'
import VueHtml2Canvas from 'vue-html2canvas'
import lodash from 'lodash'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// Axios Mock Adapter
import '@/@fake-db/db'

// 3rd party plugins
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'

// TODO: From App New
// Filter
import '@/filter/parse'

// Global Helper
Vue.mixin({
  computed: {
    userDataMe() {
      return this.$store.state.auth.userData
    },
  },
  methods: {
    toCurrency(value) {
      if (value) {
        return `Rp ${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`
      }
      return 'Rp 0'
    },
    toThousands(value) {
      if (value) {
        return `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`
      }
      return '0'
    },
    toCurrencyAbbr(value) {
      let trailer = ''
      let valueAbbr = value
      if (value > 1000000) {
        trailer = 'jt'
        valueAbbr = Math.round((valueAbbr / 1000000) * 10) / 10
      } else if (value > 1000) {
        trailer = 'rb'
        valueAbbr = Math.round(valueAbbr / 1000)
      }

      return `${this.toCurrency(valueAbbr)}${trailer}`
    },
    formatDate(date) {
      if (date) {
        const myDate = new Date(date)
        const month = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun',
          'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'][myDate.getMonth()]
        return `${myDate.getDate()} ${month} ${myDate.getFullYear()}`
      }
      return ''
    },
    formatSelectDate(date, format) {
      if (date) {
        const myDate = new Date(date)
        const month = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun',
          'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'][myDate.getMonth()]
        const hours = (`0${myDate.getHours()}`).slice(-2)
        const minutes = (`0${myDate.getMinutes()}`).slice(-2)

        return `${format.includes('date') ? myDate.getDate() : ''}`
        + `${format.includes('date') ? ' ' : ''}`
        + `${format.includes('month') ? month : ''}`
        + `${format.includes('month') ? ' ' : ''}`
        + `${format.includes('year') ? myDate.getFullYear() : ''}`
        + `${format.includes('time') ? `, ${hours}:${minutes}` : ''}`
      }
      return ''
    },
    getCurrentMonth() {
      const myDate = new Date()
      const month = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun',
        'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'][myDate.getMonth()]
      return `${month} ${myDate.getFullYear()}`
    },
    getFirstLastDate() {
      const date = new Date()
      const y = date.getFullYear()
      const m = date.getMonth()
      const firstDay = new Date(y, m, 1)
      const lastDay = new Date(y, m + 1, 0)

      const startDate = `${y}-${m + 1}-${firstDay.getDate()}`
      const endDate = `${y}-${m + 1}-${lastDay.getDate()}`

      return { startDate, endDate }
    },
    formatTime(date) {
      if (date) {
        const myDate = new Date(date)
        return `${(`0${myDate.getHours()}`).slice(-2)}:${(`0${myDate.getMinutes()}`).slice(-2)}:${(`0${myDate.getSeconds()}`).slice(-2)}`
      }
      return ''
    },
    arrayMove(arr, fromIndex, toIndex) {
      const element = arr[fromIndex]
      arr.splice(fromIndex, 1)
      arr.splice(toIndex, 0, element)
    },
    getBase64(blob) {
      return new Promise(resolve => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.readAsDataURL(blob) // read blob
      })
    },
    toSlug(text) {
      return text.toString().toLowerCase()
        .trim()
        .replace(/[^a-zA-Z0-9 ]/g, '') // Remove all special character
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/--+/g, '-') // Replace multiple - with single -
    },
    canAccess(action, resource) {
      if (this.userDataMe) {
        if (this.$ability.can(action, resource)) {
          return true
        }
        if (typeof resource === 'string') {
          const isV2 = resource.endsWith('V2')
          const equivalent = isV2 ? resource.slice(0, -2) : `${resource}V2`
          if (this.$ability.can(action, equivalent)) {
            return true
          }
          if (action === 'read') {
            if (this.$ability.can('manage', resource) || this.$ability.can('manage', equivalent)) {
              return true
            }
          }
        }
      }
      return false
    },
    canRoles(role) {
      if (this.userDataMe) {
        return this.userDataMe.role === role
      }
      return false
    },
    initialText(data, digit = 2) {
      const name = data.split(' ')
      let result = ''

      if (digit === 1) {
        const text = name[0].split('')[0]
        result = text
      } else {
        const text1 = name[0].split('')[0]
        let text2 = ''
        if (name[1]) {
          // eslint-disable-next-line prefer-destructuring
          text2 = name[1].split('')[0]
        }

        result = `${text1}${text2}`
      }

      return result
    },
    linkStaging(data, w = 32, h = 32) {
      if (data) {
        const result = data.replace('staging/', '')
        // eslint-disable-next-line radix
        return `${result}?tr=w-${parseInt(w)},h-${parseInt(h)},lo-true,q-30,fo-top`
      }
      return data
    },
    linkReplaceStaging(data) {
      if (data) {
        const result = data.replace('staging/', '')
        // eslint-disable-next-line radix
        return result
      }
      return data
    },
    toExternalLink(url, blank = true) {
      window.open(`${process.env.VUE_APP_CLIENT_URL}${url}`, blank ? '_blank' : '')
    },
    showImage(url, title = 'Preview Media') {
      const h = this.$createElement
      // Using HTML string
      const titleVNode = h('div', { domProps: { innerHTML: title } })
      // More complex structure
      const messageVNode = h('div', { class: ['foobar'] }, [
        h('img', { attrs: { src: url }, class: ['img-preview'] }),
      ])
      // We must pass the generated VNodes as arrays
      this.$bvModal.msgBoxOk([messageVNode], {
        title: [titleVNode],
        footerClass: 'd-none',
        centered: true,
        size: 'sm',
      })
    },
    showVideo(url, title = 'Preview Media') {
      const h = this.$createElement
      // Using HTML string
      const titleVNode = h('div', { domProps: { innerHTML: title } })
      // More complex structure
      const messageVNode = h('div', { class: ['foobar'] }, [
        h('video', {
          attrs: {
            src: url, controls: true, width: '100%', height: '500px',
          },
          class: ['video-preview'],
        }, [
          h('source', { attrs: { src: url, type: 'video/mp4' } }),
        ]),
      ])
      // We must pass the generated VNodes as arrays
      this.$bvModal.msgBoxOk([messageVNode], {
        title: [titleVNode],
        footerClass: 'd-none',
        size: 'md',
      })
    },
    paginationHandle(endpoin, data) {
      this.$store.dispatch(endpoin, data)
    },
    statusedProduct(data) {
      switch (data) {
        case true:
        case 1:
          return {
            type: 'success',
            text: 'Aktif',
          }
        case false:
        case 0:
        default:
          return {
            type: 'secondary',
            text: 'Tidak Aktif',
          }
      }
    },
    onCopy(data, contex) {
      try {
        navigator.clipboard.writeText(data)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `${contex} Berhasil disalin`,
            icon: 'BellIcon',
          },
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `${contex} Gagal disalin`,
            icon: 'BellIcon',
            variant: 'danger',
          },
        })
      }
    },
    async onSaveLastQueryLocal() {
      const { query } = this.$route
      await localStorage.setItem(this.$route.meta.localstorage.query, JSON.stringify({ ...query }))
    },
    async onGetLastQueryLocal() {
      if (this.$route.meta.localstorage) {
        const queryLocal = await JSON.parse(localStorage.getItem(this.$route.meta.localstorage.query))

        return queryLocal
      }
      return false
    },
    async onInitLastQueryLocal() {
      const { query } = this.$route
      const queryLocal = await JSON.parse(localStorage.getItem(this.$route.meta.localstorage.query))

      if (queryLocal) {
        await this.$router.push({ query: { ...query, ...queryLocal } }).catch(() => {})
      }
    },
    async onClearQueryLocal() {
      await localStorage.removeItem(this.$route.meta.localstorage.query)
    },
  },
})

// BSV Plugin Registration
Vue.use(ToastPlugin)
// Vue.prototype.$toast = this.$bvToast
Vue.use(ModalPlugin)
// TODO: From App New
Vue.use(VBTooltipPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// Lodash
Vue.use(VueLodash, { lodash })

Vue.use(Print)

Vue.use(VueHtml2Canvas)

// import core styles
require('@core/scss/core.scss')

require('@core/assets/fonts/feather/iconfont.css')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
